export class CommunicationLogType {
    constructor(
        public id: number = 0,
        public name: string = null
    ) { }
}